import LiveCampaignPartial from "../../partials/campaign/live-campaign.partial";

export default function LiveCampaignScreen() {
  return <LiveCampaignPartial />;
}
